import React, { useState } from 'react';
import { getEmbedUrlForId } from './youtube';
export var YoutubeIframe = function (_a) {
    var youtubeId = _a.youtubeId;
    var _b = useState(false), iframeLoaded = _b[0], setIframeLoaded = _b[1];
    var handleLoadIframe = function () {
        setIframeLoaded(true);
    };
    var origin = typeof window === 'undefined' ? '' : window.location.origin;
    return (React.createElement("div", { className: "faq-answer-youtube" },
        React.createElement("iframe", { className: iframeLoaded ? '' : 'hidden', onLoad: handleLoadIframe, src: getEmbedUrlForId(youtubeId, { rel: '0', origin: origin }), title: "YouTube video player", allow: "fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" })));
};
//# sourceMappingURL=YoutubeIframe.js.map